module.exports = ".modal-dialog {\n  width: 530px;\n  max-height: 390px;\n  max-width: none;\n  overflow-y: auto; }\n\n.vig {\n  margin-left: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/edit-lc/edit-lc.component.scss
// module id = ./src/app/account-client/component/account-client-details/edit-lc/edit-lc.component.scss
// module chunks = main